import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IProgress {
  count: number;
  total: number;
  allDataFetched: boolean;
}

const initialState: IProgress = {
  count: 0,
  total: 0,
  allDataFetched: false,
};

const progressSlice = createSlice({
  name: 'progress',
  initialState: initialState,
  reducers: {
    setTotalProgress: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    updateProgressCount: (state) => {
      state.count += 1;
      if (state.count === state.total) state.allDataFetched = true;
    },
    setAllDataFetched: (state) => {
      state.allDataFetched = true;
      state.count = 0;
    },
  },
});

export const { setTotalProgress, updateProgressCount, setAllDataFetched } =
  progressSlice.actions;

export default progressSlice.reducer;
